import { http } from "./http";

export type AckResetDto = {
  note?: string;
  force?: boolean;
};

export const alarmsApi = {
  ackReset: (token: string | null, alarmId: string, dto: AckResetDto) =>
    http<any>(`/alarms/${alarmId}/ack-reset`, { method: "POST", body: JSON.stringify(dto) }, token),

  ackResetForMachine: (token: string | null, machineId: string, dto: AckResetDto) =>
    http<any>(`/alarms/machines/${machineId}/ack-reset-all`, { method: "POST", body: JSON.stringify(dto) }, token),
};